module.exports = __webpack_public_path__ + "img/uy.3cfb7a9e.png";